import styles from "./HorizonalLine.module.scss";

const HorizontalLine = () => <hr className={styles.hr} />

export default HorizontalLine;
